export var OpenIdIdentityIssuerType;
(function (OpenIdIdentityIssuerType) {
    OpenIdIdentityIssuerType["GOOGLE"] = "google";
})(OpenIdIdentityIssuerType || (OpenIdIdentityIssuerType = {}));
export const isOpenIdIdentityIssuerType = (value) => Object.values(OpenIdIdentityIssuerType).includes(value);
export var LocalIssuerTypes;
(function (LocalIssuerTypes) {
    LocalIssuerTypes["EMAIL"] = "email";
})(LocalIssuerTypes || (LocalIssuerTypes = {}));
//# sourceMappingURL=openIdIdentity.js.map